import { forwardRef, ForwardedRef } from "react";
import { LinkMenuItem as LinkMenuItemType } from "../HeaderMenuTypes";
import BaseMenuItem from "./BaseMenuItem";

interface LinkMenuItemProps {
  item: LinkMenuItemType;
}

export default function LinkMenuItem({
  item: { ...baseMenuItem },
}: LinkMenuItemProps) {
  return <BaseMenuItem {...baseMenuItem} />;
}

interface LinkButtonProps {
  url: string;
}

const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(function (
  { url }: LinkButtonProps,
  ref: ForwardedRef<HTMLAnchorElement>
) {
  return <a href={url} ref={ref} />;
});
